export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">用户热评</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              看看大家对热门视频合集的真实评价
            </p>
          </div>

          <div className="space-y-5">
            <div className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/70">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-700 font-bold text-sm">风</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-semibold text-foreground-900">风中追风</span>
                    <span className="text-xs text-foreground-400">3小时前</span>
                  </div>
                  <div className="flex items-center gap-0.5 mb-2">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-accent-500 text-xs"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    青青草视频的影视大全做得真不错！妖精视频和桃花视频的内容都能在这里找到，热门视频合集更新也很快，每天都有新的好片子看，推荐给大家！
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/70">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-700 font-bold text-sm">夜</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-semibold text-foreground-900">夜色微凉</span>
                    <span className="text-xs text-foreground-400">昨天</span>
                  </div>
                  <div className="flex items-center gap-0.5 mb-2">
                    {[1, 2, 3, 4].map((s) => (
                      <i key={s} className="ri-star-fill text-accent-500 text-xs"></i>
                    ))}
                    <i className="ri-star-line text-accent-500 text-xs"></i>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    苹果视频和榴莲视频的资源都有收录，视频合集做得挺全的。就是希望首页能多加一些分类筛选功能，方便快速找到感兴趣的视频内容。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/70">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-secondary-700 font-bold text-sm">大</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-semibold text-foreground-900">大海捞针</span>
                    <span className="text-xs text-foreground-400">2天前</span>
                  </div>
                  <div className="flex items-center gap-0.5 mb-2">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-accent-500 text-xs"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    朋友推荐的青青草视频，说这里有豆花视频和菠萝视频的资源，果然没让我失望！热门视频合集质量很高，每天刷一刷已经成为习惯了，必须五星好评！
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}